import {
  FeiertagskontoEinstellungen,
  Kontoausgleiche,
  mappedKontoausgleicheArt,
} from '@/domain/mitarbeiter/features/feiertagskonto/entities';
import { Feiertagskonto } from '@/domain/mitarbeiter/features/feiertagskonto/entities/Feiertagskonto';
import { GET_FEIERTAGSKONTO } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useFeiertagskonto/graphql/queries';
import { useSuspenseQuery } from '@apollo/client/react';

type UseFeiertagskontoResult = {
  feiertagskonto: Feiertagskonto | null;
  feiertagskontoEinstellungen: FeiertagskontoEinstellungen;
};

export function useFeiertagskonto({
  mitarbeiterId,
  zeitraum,
  standortId,
}: {
  mitarbeiterId: string;
  zeitraum: { von: string; bis: string };
  standortId: string;
}): UseFeiertagskontoResult | null {
  const standortIds = [standortId];

  const { data, error } = useSuspenseQuery(GET_FEIERTAGSKONTO, {
    variables: {
      standortIds,
      zeitraum: {
        von: zeitraum.von,
        bis: zeitraum.bis,
      },
    },
  });
  if (error) {
    throw new Error(error.message);
  }
  const filteredMaId = data.mitarbeiter_mitarbeiterByStandortIds.find(
    (item) => item.uid === mitarbeiterId,
  );
  if (filteredMaId === undefined) {
    return null;
  }

  const mitarbeiterName = `${filteredMaId.vorname} ${filteredMaId.nachname}`;

  const isFeiertagskontoAktive =
    filteredMaId.feiertagskontoEinstellungen.isFeiertagskontoEnabled;

  const feiertagskontoEinstellungen = {
    isFeiertagskontoAktive: isFeiertagskontoAktive,
    mitarbeiterName: mitarbeiterName,
  };

  if (isFeiertagskontoAktive === false) {
    return {
      feiertagskonto: null,
      feiertagskontoEinstellungen: {
        isFeiertagskontoAktive: isFeiertagskontoAktive,
        mitarbeiterName: mitarbeiterName,
      },
    };
  }

  const kontoausgleicheMap = filteredMaId.feiertagskonto.kontoausgleiche;

  const kontoausgleiche: Kontoausgleiche[] = kontoausgleicheMap.map(
    (ausgleiche) => ({
      art: mappedKontoausgleicheArt(ausgleiche.art),
      bemerkung: ausgleiche.bemerkung,
      tage: ausgleiche.tage,
      datum: ausgleiche.datum,
    }),
  );
  const feiertagskonto = {
    mitarbeiterName: mitarbeiterName,
    isFeiertagskontoAktive: isFeiertagskontoAktive,
    kontostand: filteredMaId.feiertagskonto.kontostand,
    uebertragAusVorjahr: filteredMaId.feiertagskonto.uebertragAusVorjahr,
    kontoausgleiche,
  };
  return { feiertagskonto, feiertagskontoEinstellungen };
}
